<template>
  <div>
    <v-container fluid>
      <v-row dense>
        <v-col>
          <v-card style="background-color: #1b437c" dark>
            <center>
                  <v-simple-table>
              <template v-slot:default>
                   <tbody>
                  <tr>
                    <td>รหัสพนักงาน: </td>
                    <td>{{ profile.empCode }}</td>
                  </tr>
                  <tr>
                    <td>ชื่อ นามสกุล: </td>
                    <td>{{ profile.empFull_NameTH }}</td>
                  </tr>
                  <tr>
                    <td>เบอร์โทร: </td>
                    <td>{{ profile.empTel }}</td>
                  </tr>
                  <tr>
                    <td>อีเมล: </td>
                    <td>{{ profile.empEmail }}</td>
                  </tr>
                  <tr>
                    <td>ตำแหน่ง: </td>
                    <td>{{ profile.positionName }}</td>
                  </tr>
                  <tr>
                    <td>แผนก: </td>
                    <td>{{ profile.masDepartmentName }}</td>
                  </tr>
                  <tr>
                    <td>สาขา: </td>
                    <td>{{ profile.masBranchName }}</td>
                  </tr>
                  <tr>
                    <td>บริษัท: </td>
                    <td>{{ profile.masCompanyName }}</td>
                  </tr>
                </tbody>
                </template>
            </v-simple-table>
            </center>
          </v-card>
           <p></p>
          <v-divider class="mx-4"></v-divider>
          <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
// import axios from 'axios'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Info',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      imageUrlBack: ''
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.profile.empImageUrl = this.DNS_IP + '/' + this.profile.empImageUrl
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/RegisterCovidShow.vue